import React, { useState, useEffect } from "react";
import styles from "../serverAppPaymentScreens.module.scss";
import { connect } from "react-redux";
import cn from "classnames";
import { LABEL, CUSTOM_MESSAGES } from "../../../veriables";
import { COUNTRY_CODE } from "@constants";
import { findIndex } from "lodash";
import { getObjectValue } from "@utility/utills";
import KeyboardForOrder from "@components/OrderMenuTopScreen/keyboardForOrderMenuCopy";
import FullWidthModal from "@components/common/Modal/FullWidthModal";
import {
  addToStage,
  deleteStage,
  renameToStage,
} from "@reducers/stage";
import {
  setSeat,
  removeWithPaymentStages,
  updateWithPaymentStages,
} from "@reducers/orders";
import { bindActionCreators } from "redux";
import { generateRandomString } from "@utility/helperFunction";
import { setNotification, setErrorPopUp } from "../../../reducers/notification";
import { ReactComponent as BackChevron } from "@assets/images/backChevron.svg";
import { ReactComponent as DeleteIcon } from "@assets/images/delete.svg";
import style from "./index.module.scss";
import { ReactComponent as ExpandMore } from "@assets/images/expand_more.svg";
import { ReactComponent as LightExpandMore } from "@assets/images/light_expand_more.svg";
import { ReactComponent as Edit } from "@assets/images/edit/edit.svg";
import { TouchableButton, TouchableDiv } from '@components/common/Touchable';
import { ReactComponent as SuccessIcon } from '@assets/images/check_circle.svg';
import ModalHeader from "../../common/ModalHeader/index";
import CreateCheck from "./Modal/index";
import NotesIcon from '@assets/images/NotesIcon';
import SplitBySeatPortrait from "./splitbySelectedSeatPortrait";
import SplitBySeatLandScape from "./SplitBySelectedSeatLandScape";
import { FormatLoyaltyPhoneNumber } from '@utility/helperFunction';

const SplitBySelectedSeats = ({
  seat,
  history,
  auth,
  renameToStage,
  deleteStage,
  removeWithPaymentStages,
  setSeat,
  setNotification,
  node,
  deviceInfo,
  userInfo,
  addToStage,
  updateWithPaymentStages,
  setPaymentType,
  handleOpenDeleteModal,
  handleOpenEditModal,
  handleStageMove,
  handleStageSelection,
  handleItemSelection,
  handleCheckItems,
  selectedItem,
  selectedSeats,
  selectedStage,
  seatItemHashTable,
  tableData,
  setTableData,
  handleStagePaymentSubmit,
  onClearSplit,
  handleCardSelection,
  handleBackButtonClick,
  setErrorPopup,
  serverAppTheme,
  handleCheckAllItems,
  setErrorPopUp,
  menuItemsHashTable,
  orderingPortraitOrientation
}) => {
  const [availableSeats, setAvailableSeats] = useState([]);
  const [seatList, setSeatList] = useState([]);
  const [isEditModalOpen, setIsEditModalOpen] = useState({
    isEditOpen: false,
    data: {},
  });
  const [seatDataToDisplay, setSeatDataToDisplay] = useState([]);
  const serverAppThemeNumber = getObjectValue(
    () => JSON.parse(window.sessionStorage.getItem("auth")).serverAppTheme,
    1,
  );
  const [isDisplayItems, setIsDisplayItems] = useState({});
  const [isLoyaltyOpen, setIsLoyaltyOpen] = useState(false);
  const [loyaltyDatas, setLoyaltyDatas] = useState([]);
  const [singleLoyalty, setSingleLoyalty] = useState();

  const handleLoyaltyItem = () => {
    if (!singleLoyalty?.id) {
      setErrorPopUp({
        res: `${LABEL().SSE_ERR_LOYALTY_ACCOUNT}`,
        noErrorTxt: true,
      });
    } else {
      const { splits } = JSON.parse(window.sessionStorage.getItem("seat"));
      const dataObj = {
        id: generateRandomString(8),
        name: "",
        number:
          (splits?.reduce((max, val) => Math.max(max, val.number), 0) ||
            splits?.length) + 1,
        status: 0,
        seats: seatList.map((id) => ({ seatId: id })),
        loyalty: singleLoyalty
      };
      updateWithPaymentStages([dataObj]);
      setSeatList([]);

      setIsLoyaltyOpen(false);
    }
  }

  const toggleDisplayItems = (seatId) => {
    setIsDisplayItems((prev) => ({
      ...prev,
      [seatId]: !prev[seatId],
    }));
  };

  const countryCode = getObjectValue(
    () => COUNTRY_CODE[auth.country].dialCode,
    "1",
  );
  const getTotalAmount = (amount) => {
    return Number(amount) > 0 ? +amount.toFixed(2) : 0;
  };

  let priorTotalAmount = 0;
  const isAllSeatsStaged = (() => {
    const seatIds = seat.seats.reduce((a, v) => {
      if (v.open) {
        a.push(v.id);
      }
      return a;
    }, []);
    const paymentStagesSeats = seat?.splits?.reduce((a, v) => {
      if (v.status === 0 && v?.seats?.length > 0) {
        v.seats.forEach(({ seatId }) => a.push(seatId));
      }
      return a;
    }, []);
    return paymentStagesSeats.length === seatIds.length;
  })();
  const paymentStageItemsArrayWithSplitValue = [];

  seat?.splits?.forEach((paymentStageData, i) => {
    if (paymentStageData?.splitType != 0) {
      const itemsArray = [];
      let subTotalAmount = 0;
      let serviceChargeAmount = 0;
      let discountAmount = 0;
      seat.items.forEach((it) => {
        let price = 0;
        let flag = false;
        let count = 0;
        paymentStageData.seats.forEach((nSeat) => {
          const index = findIndex(it.seats, (d) => d.seatId === nSeat.seatId);
          if (index !== -1) {
            flag = true;
            count += 1;
            price += it.seats[index].splitAmount;
          }
        });
        if (flag) {
          subTotalAmount += price;
          itemsArray.push({
            ...it,
            isCheck: false,
            oldPrice: it.price,
            price,
            splitValueString:
              count === it?.seats?.length
                ? ""
                : `${count}/${it?.seats?.length} `,
            splitValue: count === it?.seats?.length ? 1 : count + 1,
            quantityString: `${it?.quantity * count}/${it?.seats?.length}`,
          });
        }
      });
      paymentStageItemsArrayWithSplitValue.push(itemsArray);
      seat.serviceCharges.forEach((serviceCharge) => {
        let serviceChargeValue = 0;
        let flag = false;
        paymentStageData.seats.forEach((nSeat) => {
          const index = findIndex(
            serviceCharge.seats,
            (d) => d.seatId === nSeat.seatId,
          );
          if (index !== -1) {
            flag = true;
            serviceChargeValue += serviceCharge.seats[index].splitAmount;
            itemsArray.push({
              ...serviceCharge,
              menuItemName: serviceCharge.serviceChargeName,
              price: serviceCharge.seats[index].splitAmount,
              service: true,
            });
          }
        });
        if (flag) {
          serviceChargeAmount += serviceChargeValue;
        }
      });
      seat.discounts.forEach((discount) => {
        let discountValue = 0;
        let flag = false;
        paymentStageData.seats.forEach((nSeat) => {
          const index = findIndex(
            discount.seats,
            (d) => d.seatId === nSeat.seatId,
          );
          if (index !== -1) {
            flag = true;
            discountValue += discount.seats[index].splitAmount;
            itemsArray.push({
              ...discount,
              menuItemName: discount.discountName,
              price: discount.seats[index].splitAmount,
              discount: true,
            });
          }
        });
        if (flag) {
          discountAmount += discountValue;
        }
      });
      const taxAmt = +((subTotalAmount * seat.taxAmount) / seat.itemAmount);
      const lastStageTaxAmount = +(
        seat?.unpaidAmount -
        priorTotalAmount -
        subTotalAmount +
        discountAmount
      );
      const taxAmount =
        isAllSeatsStaged &&
          i === seat?.splits?.length - 1 &&
          lastStageTaxAmount > 0
          ? +lastStageTaxAmount
          : +taxAmt;
      const totalAmount =
        countryCode === "44"
          ? getTotalAmount(
            +(subTotalAmount + serviceChargeAmount - discountAmount),
          )
          : getTotalAmount(
            +(
              taxAmount +
              subTotalAmount +
              serviceChargeAmount -
              discountAmount
            ),
          );
      if (paymentStageData.status === 0) {
        priorTotalAmount += totalAmount;
      }
      seatItemHashTable[paymentStageData.id] = {
        paymentStageId: paymentStageData.id,
        items: itemsArray,
        taxAmount,
        subTotalAmount,
        ...paymentStageData,
        totalAmount,
        unpaidAmount: +(
          taxAmount +
          subTotalAmount +
          serviceChargeAmount -
          discountAmount
        ).toFixed(2),
        paidAmount: 0,
        serviceChargeAmount: +serviceChargeAmount.toFixed(2),
        discountAmount: +discountAmount.toFixed(2),
        // loyalty: paymentStageData.id === 77496 ? {
        //     "id": 22283,
        //     "accountNumber": "00f7826d69c4416ebe9e8f572dbdcfc9",
        //     "displayAccountNumber": "3333333333",
        //     "method": "phone",
        //     "memberId": null,
        //     "vendorId": 8,
        //     "vendorName": null,
        //     "seatId": 506090,
        //     "loyaltyPostingStatus": 0
        // } : {
        //     "id": 22283,
        //     "accountNumber": "00f7826d69c4416ebe9e8f572dbdcfc9",
        //     "displayAccountNumber": "2145550001",
        //     "method": "phone",
        //     "memberId": null,
        //     "vendorId": 8,
        //     "vendorName": null,
        //     "seatId": 506090,
        //     "loyaltyPostingStatus": 0
        // },
      };
    }
  });

  useEffect(() => {
    setTableData({
      splits: seatItemHashTable,
      seats: seat.seats.reduce((a, v) => {
        a.push(v);
        return a;
      }, []),
      stageItemsArray: paymentStageItemsArrayWithSplitValue.flat(1),
    });
  }, [seat]);

  const reqSeatIds = (array) => {
    return array.map((e) => {
      return (
        e.seats &&
        e.seats?.map((d) => {
          return d.seatId;
        })
      );
    });
  };

  useEffect(() => {
    const occupiedSeats = reqSeatIds(seat?.splits);
    setAvailableSeats(occupiedSeats.flat());
  }, [seat]);

  const renameStage = (data, isDelete) => {
    if (!isDelete) {
      const previousSeatObj = JSON.parse(window.sessionStorage.getItem("seat"));

      previousSeatObj?.splits?.map((el) => {
        if (el?.id === isEditModalOpen?.seatId) {
          el.name = data;
        }
        return el;
      });
      setSeat(previousSeatObj);
      setIsEditModalOpen({ isEditOpen: false, data: {} });
    } else {
      removeWithPaymentStages(isEditModalOpen?.data);
      setIsEditModalOpen({ isDeleteOpen: false, data: {} });
    }
  };

  const addStage = () => {
    const { splits } = JSON.parse(window.sessionStorage.getItem("seat"));

    if (seatList.length === 0) { // seatId = [505208, 505209]
      console.log("error popup");
      setErrorPopUp({
        res: CUSTOM_MESSAGES().SBSS_SELECT_SEATS_TO_CREATE_SPLIT_CHECK,
        noErrorTxt: true,
        onClickChange: () => {},
      });

    } else {
      const nonNullLoyalties = seat?.seats
        .filter(seat => seatList.includes(seat.id))
        .map(seat => seat.loyalty)
        .filter(loyalty => loyalty != null);

      if (nonNullLoyalties.length > 1) {
        setLoyaltyDatas(nonNullLoyalties);
        setIsLoyaltyOpen(true);
        return null;
      } else {
        const dataObj = {
          id: generateRandomString(8),
          name: "",
          number:
            (splits?.reduce((max, val) => Math.max(max, val.number), 0) ||
              splits?.length) + 1,
          status: 0,
          seats: seatList.map((id) => ({ seatId: id })),
          loyalty: nonNullLoyalties[0] ?? null
        };

        updateWithPaymentStages([dataObj]);
        setSeatList([]);
        return dataObj;
      }
    }
  };


  const addToSeatList = (value) => {
    if (seatList.includes(value)) {
      return setSeatList(seatList.filter((item) => item !== value));
    }
    return setSeatList([...seatList, value]);
  };

  const clearAll = (splits) => {
    const dataToSend = {
      storeId: deviceInfo.storeId,
      deviceId: deviceInfo.deviceId,
      employeeId: userInfo.id,
      employeeCard: userInfo.employeeCard,
      checkHeaderId: seat.id,
      stages: [
        {
          paymentStageId: splits && splits[0] && splits[0].id,
        },
      ],
    };
    return (
      splits.length > 0 &&
      deleteStage(dataToSend)
        .then(() => {
          const index = findIndex(splits, (e) => e.id === splits[0].id);
          splits.splice(index, 1);
          removeWithPaymentStages(splits[0]).then(() => {
            return splits.length > 0 && clearAll(splits);
          });
        })
        .catch((err) => { })
    );
  };

  const handlePayment = (isCross) => {
    const splits = seat?.splits || [];
    const splitsToSend = splits
      ?.filter((el) => el?.status === 0 && el?.splitType !== 0)
      ?.map((el) => {
        const seatsToSend = el?.seats?.map((val) => val.seatId); // concept
        const checkSplitId = String(el?.id)?.includes("id") ? null : el?.id;
        let checkLoyaltyId = null;
        if ("loyalty" in el) {
          checkLoyaltyId = el?.loyalty?.id ?? null
        } else {
          const isLoyalty = seat?.loyalties?.find(
            (loy) => loy.checkSplitId === el.id
          );
          checkLoyaltyId = isLoyalty?.id ?? null;
        }        
        return {
          checkSplitId: checkSplitId,
          name: getEditedTableName(el?.id),
          seatIds: seatsToSend,
          checkLoyaltyId
        };
      });

    const payload = {
      storeId: deviceInfo?.storeId,
      deviceId: deviceInfo?.deviceId,
      employeeId: seat?.employeeId,
      employeeCard: null,
      checkHeaderId: seat?.id,
      splitType: 2,
      splits: splitsToSend,
    };

    handleStagePaymentSubmit({ payload, isSplitBySelectedSeat: true, isCross });
  };

  const getEditedTableName = (splitId) => {
    const splitsArr = tableData?.splits || [];
    const seatData = splitsArr && Object.values(splitsArr);

    const requiredSplit = seatData?.find((el) => el.id === splitId);

    return requiredSplit?.name || null;
  };


  const getSeatItems = (seatId, seatNumber) => {
    const isSeatIdPresent = seatDataToDisplay.some(
      (item) => item.seatId === seatId,
    );

    if (!isSeatIdPresent) {
      const { items, serviceCharges, discounts } = JSON.parse(
        window.sessionStorage.getItem("seat"),
      );

      const seatItems = items?.filter((el) => el?.seats?.some(check => check?.seatId === seatId)).map(el => ({
        ...el,
        splitAmount: el?.seats?.find((item) => seatId === item?.seatId)?.splitAmount || el?.price
      }))
      seatItems?.length > 0 &&
        seatItems?.forEach((el) => {
          el.splitValue = el?.seats[0]?.splitValue || 1;
        });

      const seatDiscount =
        discounts
          ?.filter((el) => el.seats?.some((check) => check?.seatId == seatId))
          ?.map((el) => ({
            ...el,
            seatNumber: seatId,
            splitValue: el?.seats[0]?.splitValue || 1,
            menuItemName: el?.discountName,
            price: el?.seats?.find((item) => seatId === item?.seatId)?.splitAmount || el?.value,
            splitAmount: el?.seats?.find((item) => seatId === item?.seatId)?.splitAmount || el?.value,
          })) || [];

      const seatServiceCharge =
        serviceCharges
          ?.filter((el) => el.seats?.some((check) => check?.seatId == seatId))
          ?.map((el) => ({
            seatNumber: seatId,
            splitValue: el?.seats[0]?.splitValue || 1,
            menuItemName: el?.serviceChargeName,
            price: el?.seats?.find((item) => seatId === item?.seatId)?.splitAmount || el?.price,
            splitAmount: el?.seats?.find((item) => seatId === item?.seatId)?.splitAmount || el?.price
          })) || [];

      const obj = {
        seatNumber,
        seatItems: [...seatItems, ...seatDiscount, ...seatServiceCharge],
        seatId,
      };

      if (seatItems.length > 0) {
        setSeatDataToDisplay((prev) => [...prev, obj]);
      }
    } else {
      setSeatDataToDisplay((prev) => prev.filter((el) => el.seatId !== seatId));
    }
  };

  const tileCheckedStatus = (i, checked, index) => {
  }

  const ItemList = (items) => {
    return items.length > 0 ? (
      items.map((i, index) => {
        const isGiftCardSplit =  menuItemsHashTable[i?.menuItemId]?.cardType ===2;
        return (
          <div
            className={cn(
              "col-12 rounded row m-0 fw-500 px-0 py-2 px-2 mb-1", orderingPortraitOrientation ? 'fs_12' : 'fs_16'
            )}
            style={{
              backgroundColor: [selectedItem].some((e) => e.id === i.id)
                ? serverAppTheme?.stage_tab_button_selected
                : serverAppTheme?.tip_tile,
              border:
                [selectedItem].some((e) => e.id === i.id) &&
                serverAppTheme?.cartSelectedBorder,
            }}
          >
            <TouchableDiv className="col-1 p-0 d-flex align-items-center">
              {!isGiftCardSplit &&
              <input
                type="checkbox"
                id={i.id}
                onChange={() => { }}
                className={cn(style.checkbox, orderingPortraitOrientation ? style.checkBoxSizeSplitPortrait : style.checkBoxSizeSplit)}
                style={{
                  border: i?.isCheck ? "none" : serverAppTheme?.checkbox_border,
                  "--checkbox-checked-color":
                    serverAppTheme?.checkbox_check_color,
                  '--checkbox-checked-bg': serverAppTheme?.checkbox_checked
                }}
                onClick={(e) => {
                  handleCheckItems(i, e.target.checked, index);
                  tileCheckedStatus(i, e.target.checked, index)
                }}
                checked={i.isCheck || false}
              />}
            </TouchableDiv>
            <TouchableDiv
              className="col-11 row m-0 p-0"
              role="button"
              tabIndex="0"
              onClick={() => !isGiftCardSplit && handleCheckItems(i, !i?.isCheck, index)}
            >
              <div className="col-7 pl-2 pr-0 d-flex align-items-center">
                {i.menuItemName}
              </div>
              <div className="col-1 px-0 pl-1 d-flex align-items-center justify-content-center">
                {i.seats &&
                  i.seats.length > 0 &&
                  i.seats[0].splitValue > 1 &&
                  i.quantity
                  ? i.quantityString
                  : i.quantity}
              </div>
              <div className="col-4 px-0 text-right d-flex align-items-center justify-content-end">
                {i?.discountId ? (
                  <>
                    -{LABEL().CURRENCY_SYMBOL}
                    {i?.value?.toFixed(2) || i?.price?.toFixed(2)}
                  </>
                ) : (
                  <>
                    {LABEL().CURRENCY_SYMBOL}
                    {i?.value?.toFixed(2) || i?.price?.toFixed(2)}
                  </>
                )}
              </div>
              <div
                className={cn("col-12 px-0")}
                role="presentation"
              >
                {i.modifiers &&
                  i.modifiers.length > 0 &&
                  renderModifier(i.modifiers)}
                {(i.note || i.comment) && (
                  <div style={{ color: serverAppTheme?.noteColor }} className={cn("col-12 row mx-0 px-0 fs-12")}>
                    <span className='col-1 px-0'>
                      <NotesIcon />
                    </span>
                    <span className={cn('pl-2 col-11 pr-0')}>
                      {i.note || i.comment}
                    </span>
                  </div>
                )}
              </div>
            </TouchableDiv>
          </div>
        );
      })
    ) : (
      <div className="h-100 fs-20 row mx-0 align-items-center justify-content-center">
        {CUSTOM_MESSAGES().NO_ITEM_FOUND}
      </div>
    );
  };

  const loyaltyTile = (loyalty) => {
    if (!loyalty) return null;

    return (
      <div
        className={cn(
          "col-12 row mx-0 mt-1 py-2 w-100 align-content-center fw-500 d-flex justify-content-between", orderingPortraitOrientation ?'fs_16' : 'fs_18'
        )}
        style={{
          background: serverAppTheme?.itemsBg,
          borderRadius: "4px",
          color: serverAppTheme?.primary_text
        }}
      >
        <div className="d-flex justify-content-start col-10 px-0">
          {LABEL().SBSS_LOYALTY}{" "}
          {loyalty?.displayAccountNumber && `(${FormatLoyaltyPhoneNumber(loyalty.displayAccountNumber)})`}
        </div>
        <div className="d-flex justify-content-end align-items-center">
          <SuccessIcon />
        </div>
      </div>
    );
  }

  const renderLoyalty = () => {
    const split = tableData.splits[selectedStage];

    if (!split) return null;

    // case 1: loyalty key exists in split
    if ("loyalty" in split) {
      return loyaltyTile(split.loyalty); // null || object
    }

    // case 2: no loyalty key in split, check loyalties array
    const matched = seat?.loyalties?.find(
      (loy) => loy.checkSplitId === split.id
    );
    return loyaltyTile(matched);
  }

  const offerTile = (selectedSplit) => {
    // Extract seatId values from selectedSplit
    const selectedSeatIds = selectedSplit?.map((s) => s.seatId);

    // Filter offers whose seatId is in selectedSeatIds
    const matchedOffers = seat?.offers?.filter((offer) =>
      selectedSeatIds.includes(offer.seatId)
    );

    return (
      <div>
        {matchedOffers?.map((offer, index) => (
          <div
            key={index}
            className={cn(
              "col-12 row mx-0 mt-1 py-2 w-100 align-content-center fs_18 fw-500 d-flex justify-content-between", orderingPortraitOrientation ? 'fs_16' : 'fs_18'
            )}
            style={{
              background: serverAppTheme?.itemsBg,
              borderRadius: "4px",
              color: serverAppTheme?.primary_text,
            }}
          >
            <div className="d-flex justify-content-start">
              {offer.name ? `${offer.name.slice(0, 18)}...` : ''}
            </div>
            <div className="d-flex justify-content-end">
              <SuccessIcon />
            </div>
          </div>
        ))}
      </div>
    );
  }

  const renderModifier = (modifiersObj, n, nest) => (
    <ul className={cn('m-0 fs_12 list-unstyled col-12 px-0')}>
      {modifiersObj?.map((modifier, index) => {
        return (
          <li className={cn('col-12 px-0 w-99', modifier?.price === 0 && 'd-none')} style={{ color: nest ? serverAppTheme?.primary_text : '#5081DE' }} key={modifier?.modifierId}>
            <div className={cn('col-12 mt-1 mx-0 px-0 row w-99', !(nest && index === 1) && 'mt-1')}>{modifier?.quantity > 1 && (<span className="col-1 px-0 mt-1 m-0 va-tt"><u className="">{modifier?.quantity}</u>  <span className=''>x</span> </span>)}
              <div className={cn("px-0 mt-1 pl-2", modifier?.quantity > 1 ? 'col-9' : (orderingPortraitOrientation ? 'col-9' : 'col-10'))}>
                {modifier?.modifierName}
              </div>
              {modifier?.price && (
                <div className={cn("text-right px-0 mt-1", orderingPortraitOrientation ? 'col-3' : 'col-2')}>
                  {LABEL().CURRENCY_SYMBOL}
                  {modifier?.price?.toFixed(2)}
                </div>
              )}
            </div>
            {(modifier?.note || modifier?.comment) && (
              <div className={cn("col-12 row mx-0 px-0 fs-12")}>
                <span className='col-1 px-0'>
                  <NotesIcon />
                </span>
                <span className={cn('pl-2 col-11 pr-0')} style={{ color: "#000" }}>
                  {modifier.note || modifier.comment}
                </span>
              </div>
            )}
            {modifier?.modifiers && modifier?.modifiers?.length > 0 && (
              <div className='d-flex col-12 px-0 w-95'>
                <div className={cn('fs_20',  style.hyphenStyle)} style={{ color: serverAppTheme?.modifier_arrowDown }}>-</div>
                <div className='col-12 px-0 pl-1 mt-1 fs_10'>
                  {renderModifier(modifier?.modifiers, n, true)}
                </div>
              </div>
            )}
          </li>
        );
      })}
    </ul>
  );
  const getMoveValue = () => {
    return getObjectValue(
      () =>
        !tableData?.splits[selectedStage]?.items?.filter((e) => e.isCheck)
          .length > 0,
      false,
    );
  };
  const checkSplitStatus = (el) => {
    const elId = el?.id;
    const splits =
      JSON.parse(window.sessionStorage.getItem("seat"))?.splits || [];
    let isStatusZero = true;
    if (elId) {
      for (let val of splits) {
        if (
          (val.seats.includes(el) && val.status === 2) ||
          (val.seats.length === 0 &&
            val.status === 2 &&
            val.number === el.number)
        ) {
          isStatusZero = false;
        }
      }
    }
    return isStatusZero;
  };

  // common props for splitbyselectedseat for portrait and landscape mode 
  const splitBySeatProps = {
  serverAppTheme,
  serverAppThemeNumber,
  tableData,
  seatDataToDisplay,
  seatList,
  availableSeats,
  selectedStage,
  isDisplayItems,
  addToSeatList,
  getSeatItems,
  checkSplitStatus,
  toggleDisplayItems,
  addStage,
  handleStageSelection,
  removeWithPaymentStages,
  handleOpenEditModal,
  handleOpenDeleteModal,
  setIsEditModalOpen,
  handlePayment,
  setSingleLoyalty,
  setSeatDataToDisplay,
  renderModifier,
};
const SplitComponent = orderingPortraitOrientation
  ? SplitBySeatPortrait
  : SplitBySeatLandScape;



  let isCheck = tableData?.splits?.[selectedStage]?.items?.every((el) => el.isCheck) && tableData?.splits[selectedStage]?.items?.length !== 0
  return (
    <div className="col-12 px-0 fs-40 font-weight-bolder h-100">
      <div className="position-absolute" style={{ height: "4%", zIndex: 1 }}>
        <TouchableDiv
          className="d-flex rounded align-items-center justify-content-center"
          style={{
            width: "2rem",
            height: "2rem",
            backgroundColor: serverAppTheme.iconcolor_bg_box,
          }}
          tabIndex="0"
          role="button"
          onClick={() => {
            handleBackButtonClick();
          }}
        >
          <BackChevron
            role="presentation"
            fill={serverAppTheme?.iconcolor}
            alt="back"
          />
        </TouchableDiv>
      </div>
      <div className={cn("col-12 d-flex justify-content-between align-items-center fw-500 px-0", orderingPortraitOrientation ? 'h-5 fs_18 pl-2' : 'h-8 fs-22')}>
        <div
          className="col-12 px-0 fw-600 text-center pb-2"
          style={{ color: serverAppTheme?.primary_text }}
        >
          {LABEL().LS_SPLIT_BY_SELECTED_SEATS}
        </div>
      </div>
      <div className={cn("d-flex col-12 p-0", orderingPortraitOrientation ? 'h-94' : 'h-92')}>
        <div
          className={cn("px-2 h-100 rounded row mx-0", orderingPortraitOrientation ? 'col-6' : 'col-8')}
          style={{ background: serverAppTheme?.subTotalBg }}
        >
         <SplitComponent {...splitBySeatProps} />

        </div>

        <div className={cn("px-0 h-100 pl-2 pr-0", orderingPortraitOrientation ? 'col-6' : 'col-4')}>
          <div className="col-12 px-0 h-100">
            <div
              className={cn("col-12 px-2 row mx-0 fw-500", orderingPortraitOrientation ? 'h-3 fs_12' : 'h-5 fs_14')}
              style={{ color: serverAppTheme?.itemQtyClr }}
            >
              <TouchableDiv className="col-1 px-0 h-100 pb-1 d-flex align-items-center">
                <input
                  type="checkbox"
                  className={cn(style.checkbox, orderingPortraitOrientation ? style.checkBoxSizeSplitPortrait : style.checkBoxSizeSplit)}
                  onClick={(e) => {
                    e.stopPropagation(); handleCheckAllItems(e.target.checked)
                  }}
                  style={{
                    border: isCheck ? "none" : serverAppTheme?.checkbox_border,
                    "--checkbox-checked-color":
                      serverAppTheme?.checkbox_check_color,
                    '--checkbox-checked-bg': serverAppTheme?.checkbox_checked
                  }}
                  checked={isCheck}
                />
              </TouchableDiv>
              <div className="col-6 pl-2 pr-0">{LABEL().ITEMS}</div>
              <div className="col-2 px-0 text-center">{LABEL().QTY}</div>
              <div className="col-3 px-0 text-right">{LABEL().AMOUNT}</div>
            </div>
            <div
              className={cn(
                "col-12 px-0 pt-1 pb-2", orderingPortraitOrientation ? 'h-81' : 'h-82'
              )}
            >
              <div className="w-100 h-100 overflowY">
                {tableData?.splits?.[selectedStage] ? (
                  <>
                    {ItemList(tableData.splits[selectedStage]?.items)}
                    {renderLoyalty()}
                    {offerTile(tableData?.splits[selectedStage]?.seats)}
                  </>
                ) : (
                  <div
                    className={cn("col-12 h-100 row mx-0 text-center fs-20 fw-400 d-flex align-content-center", orderingPortraitOrientation ? 'pr-0' : '')}
                    style={{ color: serverAppTheme?.noItemContainers }}
                  >
                    {CUSTOM_MESSAGES().SBSS_SELECT_CHECK_TO_PREVIEW_ITEMS}
                  </div>
                )}
              </div>
            </div>
            <div
              className={cn("col-12 h-50", orderingPortraitOrientation ? 'px-0': 'px-3')}
            >
              <div className={cn("h-25", !orderingPortraitOrientation ? 'row' : '')}>
                <div
                  className={cn(
                    "px-0", orderingPortraitOrientation ? 'col-12 pr-0 pb-1' : 'col-6 pr-2'
                  )}
                >
                  <TouchableButton
                    type="button"
                    className={cn("w-100 rounded border-0", !orderingPortraitOrientation ? 'h-100' : '')}
                    onClick={(e) => { e.preventDefault(); handleStageMove("splitBySelectedSeat") }}
                    disabled={getMoveValue()}
                    style={{
                      color: getMoveValue() ? serverAppTheme?.btn_font_color_disabled : serverAppTheme?.btn_font_color,
                      backgroundColor: getMoveValue() ? serverAppTheme?.secondaryBtnDisabled : serverAppTheme?.primaryBtn,
                      fontSize: '20px',
                      fontWeight: 600,
                       height: orderingPortraitOrientation ? '56px' : ''

                    }}
                  >
                    {LABEL().MOVE}
                  </TouchableButton>
                </div>

                <div
                  className={cn(
                    "px-0",orderingPortraitOrientation ? 'col-12 pr-0 pt-1' : 'col-6'

                  )}
                >
                  <TouchableButton
                    type="button"
                    className={cn("w-100 rounded border-0", !orderingPortraitOrientation ? 'h-100' : '')}
                    onClick={() => handlePayment()}
                    disabled={
                      !(
                        tableData?.splits &&
                        Object.values(tableData.splits).some(split => Number(split.status) === 0)
                      )
                    }
                    style={{
                      color:
                        tableData?.splits &&
                        Object.values(tableData.splits).some(split => Number(split.status) === 0)
                          ? serverAppTheme?.btn_font_color
                          : serverAppTheme?.btn_font_color_disabled,
                      background:
                        tableData?.splits &&
                        Object.values(tableData.splits).some(split => Number(split.status) === 0)
                          ? serverAppTheme?.enabledPayBtn
                          : serverAppTheme?.disabledPayBtn,
                      fontSize: '20px',
                      fontWeight: 600,
                      height: orderingPortraitOrientation ? '56px' : ''
                    }}
                    rippleEffect={true}
                  >
                    {LABEL().PAY}
                  </TouchableButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {isEditModalOpen.isEditOpen && (
        <FullWidthModal
          isOpen={isEditModalOpen.isEditOpen}
          noBackground
          customClass2={cn("w-100 h-100 position-relative")}
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            height: "100%",
            pointerEvents: "auto",
            backgroundColor: serverAppTheme?.popUp_bg,
            backgroundClip: "padding-box",
            border: "0",
            boxShadow: serverAppTheme?.popUp_box_shadow,
          }}
        >
          <div className="col-12 px-0 h-100 justify-content-center align-items-center position-relative text-center">
            <ModalHeader
              isTab={seat?.tab}
              stationName={seat?.stationName}
              tileHeader={LABEL().CHECK_NAME}
              seatNumber={seat?.number}
            />
            <div
              className="text-right"
              style={{
                position: "absolute",
                top: "10px",
                right: "10px",
                zIndex: "999",
              }}
            ></div>
            {isEditModalOpen.isEditOpen && (
              <KeyboardForOrder
                name="stageName"
                type="textWithoutNumeric"
                customClass="mt-2"
                specialValue={
                  isEditModalOpen?.data?.name
                    ? String(isEditModalOpen?.data?.name)
                    : ""
                }
                placeholder={CUSTOM_MESSAGES().ENTER_CHECK_NAME}
                buttonName={LABEL().SUBMIT}
                onSubmit={renameStage}
                editSeatPopUP={true}
                noBtnclass={true}
                serverAppTheme={serverAppTheme}
                cancelBtnName={LABEL().CANCEL}
                onclose={() => setIsEditModalOpen(false)}
                // header={LABEL().CHECK_NAME}
                setErrorPopUp={setErrorPopUp}
              />
            )}
          </div>
        </FullWidthModal>
      )}
      {isLoyaltyOpen && (
        <CreateCheck
          check={seat}
          isLoyaltyOpen={isLoyaltyOpen}
          serverAppTheme={serverAppTheme}
          setIsLoyaltyOpen={setIsLoyaltyOpen}
          loyaltyList={loyaltyDatas}
          setSingleLoyalty={setSingleLoyalty}
          handleLoyaltyItem={handleLoyaltyItem}
          singleLoyalty={singleLoyalty}
          setSeatList={setSeatList}
        />
      )}
    </div>
  );
};

const mapStateToProps = ({ oauth, orders, stage }) => ({
  deviceInfo: oauth.deviceInformation,
  userInfo: oauth.loggedInUserData,
  auth: oauth.authInfo,
  seat: orders.seats,
  position: orders.position,
  loading: stage.loading || orders.loading,
  isEmployeeCheck: oauth.isEmployeeCheck,
  menuItems: orders.menuItems,
  menuItemsHashTable: orders.menuItemsHashTable,
  orderingPortraitOrientation: orders.orderingPortraitOrientation
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      renameToStage,
      deleteStage,
      setSeat,
      setNotification,
      removeWithPaymentStages,
      addToStage,
      updateWithPaymentStages,
      setErrorPopUp
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SplitBySelectedSeats);
